import { isLoggedIn } from '../../../../components/common/Helpers';
import * as actionTypes from '../actionTypes';
import * as actionTypesECheckout from '../../../../components/NextGen/ExpressCheckout/@Redux/actionTypes';
import initialState from './progressivePlans.initialState';

const progressivePlansReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PROGRESSIVE_PLANS_SUCCESS:
      return {
        ...state,
        progressivePlanAPiResponse: action.response,
        getfwaplansLoaded: true,
        autoPayOn: isLoggedIn() ? action.response?.data?.autoPayEnrolled || false : true,
      };
    case actionTypes.PROGRESSIVE_PLANS_FAILURE:
      return {
        ...state,
        progressivePlanFailureAPiResponse: action.response,
      };
    case actionTypes.UPDATE_PERK_MULTIPLE_DISCLOSURE:
      return {
        ...state,
        perkMultipleDisclosureOverlay: action.response,
      };
    case actionTypes.UPDATE_PERK_DISCLOSURE:
      return {
        ...state,
        perkDisclosureOverlay: action.response,
      };
    case actionTypes.UPDATE_CHOICE_PERK:
      return {
        ...state,
        perkChoiceOverlay: action.response,
      };
    case actionTypes.DUPLICATE_PERK_DISCLOSURE:
      return {
        ...state,
        perkDuplicateOverlay: action.response,
      };
    case actionTypes.PERKS_CONFLICT_OVERLAY:
      return {
        ...state,
        perkConflictOverlay: action.response,
      };
    case actionTypes.PROGRESSIVE_PLANS_MOCK:
      return {
        ...state,
        progressivePlanMockResponse: action.response,
      };
    case actionTypes.ADD_PLAN_SUCCESS:
      return {
        ...state,
        addPlanAPiResponse: action.response,
      };
    case actionTypes.PERKS_MODAL_DETAILS_SUCCESS:
      return {
        ...state,
        perkDetails: action.response,
      };
    case actionTypes.PERKS_MODAL_DETAILS_FAILURE:
      return {
        ...state,
        perksModalDetailsFailureAPiResponse: action.response,
      };

    case actionTypes.UPDATE_SELECT_DATA_PERK_INFO:
      return {
        ...state,
        selectedPlanInfo: action.response,
        prevSelectedPlanInfo: Array.isArray(action.response) ? action.response : state.selectedPlanInfo,
        scOpen: state.scOpen ? true : !!action?.response?.selectedPlan?.planId,
      };
    case actionTypes.UPDATE_FEEDBACK_API:
      return {
        ...state,
        feedBackApi: action.response,
      };
    case actionTypes.UPDATE_FROM_PROGRESSIVE:
      return {
        ...state,
        fromProgressive: action.response,
      };
    case actionTypes.UPDATE_ERROR_NOTIFICATION_PERK:
      return {
        ...state,
        errorNotification: action.response,
      };
    case actionTypes.SET_PERK_PDP_OVERLAY:
      return {
        ...state,
        perkPdpOverlay: action.response,
      };
    case actionTypes.SET_TERMS_AND_CONDITIONS_OVERLAY:
      return {
        ...state,
        termsAndConditionsOverlay: action.response,
      };
    case actionTypes.SET_PERKS_TERMS_AND_CONDITIONS_OVERLAY:
      return {
        ...state,
        perkTermsAndConditionsOverlay: action.response,
      };
    case actionTypes.UPDATE_AUTO_PAY_STATUS:
      return {
        ...state,
        autoPayOn: action.response,
      };
    case actionTypes.NETFLIX_PLUSPLAY_OVERLAY_VALUE:
      return {
        ...state,
        netflixPlusPlay: action.response,
      };
    case actionTypes.ENABLE_CHOICE_OFFER:
      return {
        ...state,
        enableChoiceOffer: action.response,
      };
      case 'CBAND_STALL':
      return {
        ...state,
        cbandStall: action.response,
      };
    case actionTypes.UPDATE_PLANS_ACCORD_STATUS:
      return {
        ...state,
        planAccordionState: {
          show: action.response,
          lastUpdated: String(new Date()),
        },
      };
    case actionTypes.UPDATE_LQ_LOADED:
      return {
        ...state,
        lqLoaded: action.response,
      };
    case actionTypes.UPDATE_PREV_TOGGLE_EXPLORE:
      return {
        ...state,
        prevToggleExplore: action.response,
      };
    case actionTypes.CHOICE_OFFER_PROMO_ID:
      return {
        ...state,
        selectedChoiceOfferId: action.value,
      };
    case actionTypes.UPDATE_SPECIAL_OFFER_PLAN:
      return {
        ...state,
        specialOfferRequired: action.response,
      };
    case actionTypes.PLAN_CHANGED_FROM_ABANDED:
      return { ...state, planChangedAbanded: action.value };
    case actionTypes.GIFT_CARD_OFFER_MODAL_CLICKED:
      return { ...state, giftCardOfferModalClicked: action.value };
    case actionTypes.GIFT_CARD_OFFER_LINK_CLICKED:
      return { ...state, giftCardOfferLinkClicked: action.value };
    case actionTypes.GIFT_CARD_OFFER_SELECTED_RESET:
      return { ...state, giftCardOfferModalClicked: false, giftCardOfferLinkClicked: false };
    case actionTypes.UPSELL_MODAL_UPGRADE_OFFER_CLICKED:
      return { ...state, upgradeOfferClicked: action.value };
    case actionTypes.ADD_PLAN_API_CALLED:
      return { ...state, addPlanAPICalled: action.value };
    case actionTypes.ABANDON_DISCOUNT_OFFER_APPILED:
      return { ...state, abandonDiscontOfferAppiled: action.value };
    case actionTypes.SET_STREAMLINE_ORDERING:
      return {
        ...state,
        streamLineOrdering: action.value,
      };
    case actionTypes.SHOW_PERK_SAVING_NOTIFY:
      return {
        ...state,
        perkSavingsNotify: action.value,
      };
    case actionTypes.SET_STREAMLINE_PERK_REDESIGN:
      return {
        ...state,
        enablePerkRedesign: action.value,
      };
    case actionTypes.SET_VHDP_MODAL:
      return {
        ...state,
        showVhdpModal: action.value,
      };
    case actionTypes.SPECIAL_GIFTSECTION_NOTIFICATION:
      return { ...state, showSpecialGiftSectionBanner: action?.value };
    case actionTypesECheckout.EXPRESS_CHECKOUT_PERK_UP_SELL_ENABLE:
      return { ...state, isPerkUpSellAddClick: action.value };
    case actionTypes.BROWSER_BACK_REDIRECT_INCREMENT_COUNTER :
      const increaedCounter = state.browserBackRedirectCounter + 1;
      localStorage.setItem('browserBackRedirectCounter', increaedCounter);
      return {
        ...state,
        browserBackRedirectCounter: increaedCounter,
      };
    case actionTypes.BROWSER_BACK_REDIRECT_RESET_COUNTER :
        localStorage.setItem('browserBackRedirectCounter', 0);
        return {
          ...state,
          browserBackRedirectCounter: 0,
        };
    case actionTypes.SELECTED_PERK_BUNDLE_STATE:
      return {
        ...state,
        selectedPerkBundleState: action.response,
      };
    case actionTypes.SET_PERK_BUNDLE_NOTIFICATION:
      return {
        ...state,
        perkBundleNotification: action.response,
      };
    case actionTypes.PERK_BUNDLE_NOTIFICATION_OPENED:
      return {
        ...state,
        displayPerkBundleNotification: action.response,
      };
    default:
      return state;
  }
};

export default progressivePlansReducer;
